import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { Grid } from "@mui/material";

import Layout from "components/Screens/LoginV2/Layout/Layout";
import Button from "components/common/Button";
import CustomAlert from "components/common/Alert";
import PageLoader from "components/common/PageLoader";

import { showSnackbar } from "store/actions/Utility";
import { getError } from "components/Screens/CommonUtils";

import { s3ImagesBaseURL, baseUrl } from "util/APIBaseUrl";
import postRequest from "util/APIHelperPost";

import { getForgotPasswordInfo, getForgotPasswordInfoLoading } from "selectors/auth";

import { VALIDATE_TOKEN_CASES } from "components/Screens/CustomerOnboarding/constants";
import { LOGIN_ROUTE } from "constants/routes";

import "./LinkExpired.scss";

function LinkExpired() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forgotPasswordInfo = useSelector(getForgotPasswordInfo);
  const loadingForgotPasswordInfo = useSelector(getForgotPasswordInfoLoading);
  const { payload: forgotPasswordInfoPayload = {} } = forgotPasswordInfo || {};

  const [linkSendScreen, setLinkSendScreen] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);

  const token = queryParams.get("token");
  const eventParam = queryParams.get("event");

  const formatApiErrors = (errors) => {
    if (!errors) return "";
    if (Array.isArray(errors)) {
      return errors
        .map((e) => `${e?.param ? `${e.param}: ` : ""}${e?.description || e?.msg || e?.name || "Error"}`)
        .join(", ");
    }

    if (Array.isArray(errors?.error)) {
      return errors.error
        .map((e) => `${e?.param ? `${e.param}: ` : ""}${e?.description || e?.msg || e?.name || "Error"}`)
        .join(", ");
    }
    return "";
  };

  const handleResendEmail = async () => {
    try {
      const body = JSON.stringify({
        token,
      });

      const response = await postRequest(`${baseUrl}/v2/auth/resend`, body, true);
      setLinkSendScreen(true);
      const { ok, status } = response;
      if (!ok && status === 400) {
        navigate(LOGIN_ROUTE, {
          state: {
            onboardingError: VALIDATE_TOKEN_CASES.USED,
          },
        });
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          type: "error",
          message: getError(error),
          dispatch,
        })
      );
    }
  };

  const combinedErrors = forgotPasswordInfoPayload?.error;
  const errorDescription = formatApiErrors(combinedErrors);
  return (
    <Layout
      rightSideImage={
        eventParam === "Activation"
          ? `${s3ImagesBaseURL}/employee-onboarding.png`
          : `${s3ImagesBaseURL}/login-image.jpg`
      }
      contentContainerClass="employee-onboarding-link-expired-container"
    >
      {loadingForgotPasswordInfo && <PageLoader />}
      <Grid className="h-full" size={12}>
        <div className="flex flex-col items-start justify-center h-full">
          <div className="heading-h1-semibold">
            {linkSendScreen ? "A new link has been sent" : "Seems like your link has expired"}
          </div>

          {errorDescription ? (
            <CustomAlert open onClose={() => {}} severity="error" description={errorDescription} />
          ) : null}

          {linkSendScreen ? (
            <div className="para-body-m-regular color-text-body-primary mb-1">
              Check your registered email for the reset link.
            </div>
          ) : (
            <>
              <div className="para-body-m-regular color-text-body-primary mb-1">
                A new link to reset your password will be sent to your registered email address.
              </div>
              <Button label="Request a new link" size="large" className="w-100p" onClick={handleResendEmail} />
            </>
          )}
        </div>
      </Grid>
    </Layout>
  );
}

export default LinkExpired;
